module.exports = __webpack_public_path__ + "assets/img/background.6bc41f56.png";